import {Component, Input, OnInit} from '@angular/core';
import {QuestionBase} from "../../../../create-adv/models/question-base";

@Component({
    selector: 'app-dropdown-field',
    templateUrl: './dropdown-field.component.html',
    styleUrls: ['./dropdown-field.component.scss'],
    standalone: false
})
export class DropdownFieldComponent implements OnInit {

  @Input() question: QuestionBase<string>;
  @Input() value: string;
  constructor() { }

  ngOnInit(): void {
  }

  // SCRUM-145: `question.value` can be a plain string, but for dropdown /
  // select-type answers it is often the selected option object
  // ({ id, label, name, value: { value, name } } - see selectOptionData),
  // which used to be interpolated directly and rendered as "[object Object]".
  // Unwrap it to a human-readable string instead.
  get displayValue(): string {
    const val: any = this.question?.value;
    if (val === null || val === undefined || val === '') {
      return '';
    }
    if (typeof val === 'string' || typeof val === 'number') {
      return String(val);
    }
    if (typeof val === 'object') {
      return val.label ?? val.name ?? val.Type ?? val.nameHe ?? val.value?.name ?? val.value?.value ?? '';
    }
    return String(val);
  }

}
